import React, {createContext, useContext, useEffect, useState, ReactNode, useMemo, useCallback, Ref} from "react";
import {useImportFileSelect} from "./hooks/useImportFileSelect";
import {useVerifyImport} from "./hooks/useVerifyImport";
import useContactImportParser, {ImportRow} from "./hooks/useContactImportParser";


const stages = [
    "select",
    "verify",
    "submit"
] as const;

type Stage =  typeof stages[number];

interface ImportManagementContextType {
    stage: Stage;
    setStage: (stage: Stage) => void
    newImportName: string;
    setNewImportName: (newImportName: string) => void;
    fileSelect: ReturnType<typeof useImportFileSelect>;
    verify: ReturnType<typeof useVerifyImport>;
    rows: ImportRow[]
    headers: string[]
    archiveMissing: boolean
    setArchiveMissing: (archiveMissing: boolean) => void;
    matchOnEmail: boolean
    setMatchOnEmail: (matchOnEmail: boolean) => void;
    clientID: string

}

const ImportManagementContext = createContext<ImportManagementContextType | null>(null);

export const ImportManagementProvider = ({ children, clientID }: { children: ReactNode, clientID: string | null | undefined }) => {

    const [archiveMissing, setArchiveMissing] = useState<boolean>(false);
    const [matchOnEmail, setMatchOnEmail] = useState<boolean>(false);
    const fileSelect = useImportFileSelect();
    const {headers, rows, ready} = useContactImportParser(fileSelect.selectedFile);
    const verify = useVerifyImport(headers, rows, ready, clientID, matchOnEmail)

    const [newImportName, setNewImportName] = useState("");
    const [stage, setStage] = useState<Stage>("select");




    const value: ImportManagementContextType = {
        fileSelect,
        newImportName, setNewImportName,
        verify,
        stage, setStage,
        rows,
        headers,
        archiveMissing, setArchiveMissing,
        matchOnEmail, setMatchOnEmail,
        clientID: clientID || ""
    };

    return (
        <ImportManagementContext.Provider value={value}>
            {children}
        </ImportManagementContext.Provider>
    );
};

export const useImportManagement = (): ImportManagementContextType => {
    const context = useContext(ImportManagementContext);
    if (!context) {
        throw new Error("useImportManagement must be used within a ImportManagementProvider");
    }
    return context;
};